import { faArrowsRepeat } from '@fortawesome/pro-light-svg-icons'
import { useCallback } from 'react'
import { ButtonPrimary } from '../../../../../../../../../../baseComponents/Button'
import TwinIcon from '../../../../../../../../../../baseComponents/TwinIcon'
import { InputTableURLsTable } from '../../../../../../../../../../baseComponents/TwinTable/InputTableLayout/types'
import TwinTrans from '../../../../../../../../../../baseComponents/TwinTrans'
import { SellTicketButtonsProps, SetTPVCompleteDataTy, TPVOrderData } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderSellTicketTPVLayout/types'
import useIsLoading from '../../../../../../../../../../utils/hooks/useIsLoading'
import { parsedTicketTableData } from '../../../../../functions'

interface SellRefundTicketStepButtonsProps extends SellTicketButtonsProps { 
    inputTableURLs: InputTableURLsTable
    completeData: TPVOrderData
}

const SellRefundTicketStepButtons: React.FC<SellRefundTicketStepButtonsProps> = ({...rest}) => {
    return (
        <div className='flex flex-row bg-white product_ticket_buttons overflow-hidden'>
            <RestartSellTicketButton {...rest} />
        </div>
    )
}

interface RestartSellTicketButtonProps extends RestartSellTicketButtonLogicProps { }

const RestartSellTicketButton: React.FC<RestartSellTicketButtonProps> = ({ ...rest }) => {
    const { loading, handleRestartSellTicket } = useRestartSellTicketButtonLogic({ ...rest })
    return (
        <ButtonPrimary className='flex-auto flex items-center justify-center ticket_button_border charge_ticket_button_parent ' onClick={handleRestartSellTicket}>
            <TwinIcon icon={faArrowsRepeat} className={'mr-8 text-white regular20 ' + (loading ? 'hidden' : '')} />
            <span>{loading ?
                <TwinTrans transKey='processingDotsv2' >Procesando...</TwinTrans>
                : <TwinTrans transKey='newTicket'>Nuevo ticket</TwinTrans>}
            </span>
        </ButtonPrimary>
    )
}

interface RestartSellTicketButtonLogicProps extends SellRefundTicketStepButtonsProps {
    setCompleteData: SetTPVCompleteDataTy
}

const useRestartSellTicketButtonLogic = ({ setCompleteData }: RestartSellTicketButtonLogicProps) => {
    const { endLoading, loading, startLoading } = useIsLoading()
    const handleRestartSellTicket = useCallback(async () => {
        startLoading?.()
        setCompleteData((old) => {
            const copyOld = JSON.parse(JSON.stringify(old))
            copyOld.lastProductIndex = null
            copyOld.header = {}
            copyOld.tableData = []
            copyOld.Customer = {}
            delete copyOld.selectedTableData
            parsedTicketTableData(copyOld)
            return copyOld
        })
        endLoading?.()
    }, [startLoading, endLoading, setCompleteData])
    return { loading, handleRestartSellTicket }
}

export default SellRefundTicketStepButtons